module.exports = __webpack_public_path__ + "static/site-logo-c0f421eebcd0230d4e69b4f8842ae07e.png";